import { AWS_API_URL } from 'global/environment';
import { authorize, putRequest } from 'utils/http';
import { mapDataForBackend } from './mapData';

export async function updateLightningScenarioAPI(scenario) {

  return putRequest(`${AWS_API_URL}/lighting/scenarios/${scenario.id}`,
    mapDataForBackend(scenario), await authorize());
}
